import React, { useState } from "react";
import { Chip } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAppColor } from "@icarius-app/selectors";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { PRIVACY_NAMES } from "@icarius-pages/feed/constants";
import PrivacyDialog from "./privacyDialog";
import { getLocalizedString } from "@icarius-localization/strings";

const PrivacyInput = (props) => {
    const { data, groups, tasks, people, isFeedback, isInterviewAndFeedback, statusToCreate, handleChange } = props;

    const [privacyDialogIsOpen, setPrivacyDialogIsOpen] = useState(false);
    const color = useSelector(getAppColor);

    const handleClick = () => {
        setPrivacyDialogIsOpen(true);
    };

    return (
        <>
            <Chip
                label={getLocalizedString(PRIVACY_NAMES[data.type])}
                disabled={isInterviewAndFeedback}
                onClick={handleClick}
                onDelete={handleClick}
                deleteIcon={<KeyboardArrowDownIcon style={{ color: "var(--mainText)" }} />}
                style={{
                    background: color,
                    cursor: "pointer",
                    color: "white",
                }}
            />
            {privacyDialogIsOpen && (
                <PrivacyDialog
                    open={privacyDialogIsOpen}
                    data={data}
                    groups={groups}
                    tasks={tasks}
                    people={people}
                    handleChange={handleChange}
                    isFeedback={isFeedback}
                    statusToCreate={statusToCreate}
                    handleClose={() => setPrivacyDialogIsOpen(false)}
                />
            )}
        </>
    );
};

export default PrivacyInput;
